import React from "react";
import LegalPage from "./LegalPage";

export default function TermsPage() {
  return (
    <LegalPage
      eyebrow="Legal · House Rules"
      title="Terms &|Conditions."
      updated="February 2026"
      summary="The boring but important stuff. By using this website or ordering a House Rules box, you agree to these terms. If you don't, please don't order - and definitely don't play with strangers."
      sections={[
        {
          id: "acceptance",
          heading: "1. Acceptance of terms",
          body: [
            "By accessing or ordering from houserules.game, you confirm you're at least 18 years old (or have a legal guardian's consent), and that you accept these Terms & Conditions, our Privacy Policy, and our Returns Policy.",
            "If you're purchasing on behalf of a business, you represent that you have the authority to bind that business to these terms.",
          ],
        },
        {
          id: "product",
          heading: "2. The product",
          body: [
            "House Rules is an adult-friendly party card game with a family-friendly deck option. Suggested age is 8+, though certain decks (Truth or Lie, House Charades) are best with adults or teens.",
            "We reserve the right to update card contents, decks, or box design without prior notice. Any material change to the product will be clearly disclosed on the product page prior to purchase.",
          ],
        },
        {
          id: "orders",
          heading: "3. Orders, pricing & payment",
          body: [
            "All prices are listed in U.S. dollars and are exclusive of applicable sales tax, which is added at checkout where required. Payment is processed securely by Stripe - we never see or store your card details.",
            "We reserve the right to cancel or refuse an order if we suspect fraud, if a product is out of stock, or if there is a pricing error on our site. In that case we'll refund you in full within 3–5 business days.",
          ],
        },
        {
          id: "ip",
          heading: "4. Intellectual property",
          body: [
            "The House Rules brand, box art, card copy, deck illustrations, website design, and all associated trademarks are the property of Wall of Entertainment Inc. You may not reproduce, remix, or sell derivative works without written permission.",
            "You are welcome to share photos and videos of your game night on social media, tagged with #HouseRulesNight - we may repost UGC with credit.",
          ],
        },
        {
          id: "conduct",
          heading: "5. Acceptable use of the website",
          body: [
            "Don't attempt to reverse-engineer, scrape, or overload the site. Don't use the newsletter form for anything other than sign-ups. Don't submit false shipping information or fraudulent payment details.",
            "We may suspend accounts or refuse future orders if we detect abuse of the site, its promotions, or our returns policy.",
          ],
        },
        {
          id: "liability",
          heading: "6. Limitation of liability",
          body: [
            "House Rules and Wall of Entertainment Inc. will not be liable for any indirect, incidental, or consequential damages arising from use of the website or the game - including but not limited to bruised egos, broken friendships, or spilled drinks.",
            "Our total liability for any claim relating to a product is limited to the amount you paid for that product.",
          ],
        },
        {
          id: "governing",
          heading: "7. Governing law & disputes",
          body: [
            "These terms are governed by the laws of the State of California, USA. Any dispute will be resolved in the state or federal courts located in Los Angeles County, California.",
            "For questions or complaints, email hello@houserules.game before anything else. We'd rather chat than litigate.",
          ],
        },
      ]}
      related={[
        { label: "Privacy Policy", to: "/privacy" },
        { label: "Returns Policy", to: "/returns" },
        { label: "Shipping Info", to: "/shipping" },
      ]}
    />
  );
}
